const baseUrl = '';
const urlMap = {
    getReleaseNoteList: `${baseUrl}/helppanel/help-panel/listReleaseNotes`,
    getReleaseNoteById: `${baseUrl}/helppanel/help-panel/getReleaseNoteById`,
    getConfig: `${baseUrl}/helppanel/help-panel/getAssistancePanel`,
    listBizTypeTrees: `${baseUrl}/helppanel/help-panel/case/listBizTypeTrees`,
    createCaseCompatibly: `${baseUrl}/os/helppanel/case/createCaseCompatibly`,
    getDescribe: `${baseUrl}/api/question/manager/describe`,
    searchHotKnowledge: `/api/question/manager/search`,
    saveSurveyResult: `/api/helpPanel/survey/saveSurveyResult`,
};
export default urlMap;
